// LiveBetter consortium as listed in Grant Agreement No. 101215721
// (Part A, "List of participants"), kept in GA order. Names are the English
// or commonly used form of each GA legal name.
//
// Websites and logos (public/partners/) come from
// https://www.livebetterproject.eu/consortium, except EPÜ and FR, which that
// page does not cover: EPÜ operates Etele Plaza and FR is a Futureal Group
// company, so they use eteleplaza.hu and futurealgroup.com. ESC has no
// website there, so it has no `url`.

export const BENEFICIARIES = [
  {
    shortName: 'ICCS',
    name: 'Institute of Communication and Computer Systems',
    country: 'Greece',
    coordinator: true,
    url: 'https://www.iccs.gr',
    logo: '/partners/iccs.png',
  },
  {
    shortName: 'CARTIF',
    name: 'Fundación CARTIF',
    country: 'Spain',
    url: 'https://www.cartif.es/en/home/',
    logo: '/partners/cartif.png',
  },
  {
    shortName: 'UNIVPM',
    name: 'Università Politecnica delle Marche',
    country: 'Italy',
    url: 'https://www.univpm.it',
    logo: '/partners/univpm.png',
  },
  {
    shortName: 'SFLEX',
    name: 'SmartFlex Artificial Intelligence Solutions',
    country: 'Greece',
    url: 'https://smartflex.gr/',
    logo: '/partners/sflex.png',
  },
  {
    shortName: 'ABUD',
    name: 'ABUD Mérnökiroda Kft.',
    country: 'Hungary',
    url: 'https://www.abud.hu',
    logo: '/partners/abud.png',
  },
  {
    shortName: 'ECTP',
    name: 'European Construction and Sustainable Built Environment Technology Platform',
    country: 'Belgium',
    url: 'https://www.ectp.org/',
    logo: '/partners/ectp.png',
  },
  {
    shortName: 'ESC',
    name: 'Enersave Capital SARL',
    country: 'Luxembourg',
    logo: '/partners/esc.png',
  },
  {
    shortName: 'HERON',
    name: 'HERON Energy Services S.A.',
    country: 'Greece',
    url: 'https://heron.gr',
    logo: '/partners/heron.png',
  },
  {
    shortName: 'IVE',
    name: 'Instituto Valenciano de la Edificación',
    country: 'Spain',
    url: 'https://www.five.es/',
    logo: '/partners/ive.png',
  },
  {
    shortName: 'EPÜ',
    name: 'Etele Plaza Üzemeltető Kft.',
    country: 'Hungary',
    url: 'https://eteleplaza.hu/',
    logo: '/partners/epu.png',
  },
  {
    shortName: 'EAP',
    name: 'Energy Agency of Plovdiv',
    country: 'Bulgaria',
    url: 'https://www.eap-save.eu/',
    logo: '/partners/eap.png',
  },
  {
    shortName: 'LCAD',
    name: 'LCA Dynamics SIA',
    country: 'Latvia',
    url: 'https://www.lcadynamics.com',
    logo: '/partners/lcad.png',
  },
  {
    shortName: 'MoS',
    name: 'MoS S.r.l.',
    country: 'Italy',
    url: 'https://www.moseu.it/',
    logo: '/partners/mos.png',
  },
];

export const ASSOCIATED_PARTNERS = [
  {
    shortName: 'FR',
    name: 'FR Management Partnership C.V. (Hungarian branch)',
    country: 'Hungary',
    url: 'https://www.futurealgroup.com/en/',
    logo: '/partners/fr.svg',
  },
  {
    shortName: 'HPP',
    name: 'HelloParks Partnership C.V. (Hungarian branch)',
    country: 'Hungary',
    url: 'https://helloparks.com',
    logo: '/partners/hpp.png',
  },
  {
    shortName: 'LEIF',
    name: 'Latvian Environmental Investment Fund',
    country: 'Latvia',
    url: 'https://www.lvif.gov.lv',
    logo: '/partners/leif.png',
  },
  {
    shortName: 'DAEM',
    name: 'Municipality of Athens IT Company',
    country: 'Greece',
    url: 'https://www.daem.gr',
    logo: '/partners/daem.png',
  },
  {
    shortName: 'ANCE',
    name: 'Associazione Nazionale Costruttori Edili',
    country: 'Italy',
    url: 'https://ance.it/',
    logo: '/partners/ance.png',
  },
];
